<template>
  <div class="flex justify-center">
    <div v-if="getRoles && getRoles.length" class="p-6 px-8 lg:w-1/5">
      <div class="rounded-md overflow-hidden shadow-lg py-5 px-2">
        <h1 class="text-md font-light text-center text-secondary pb-4">
          Roles creados
        </h1>
        <template v-for="(role, i) in getRoles" :key="i">
          <div class="flex px-4">
            <p class="w-full text-sm font-medium text-secondary pb-2">
              {{ role.name }}
            </p>
            <button @click="onDelete(role.key)">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M5.28544 2.14118H5.14258C5.22115 2.14118 5.28544 2.0769 5.28544 1.99833V2.14118H10.714V1.99833C10.714 2.0769 10.7783 2.14118 10.8569 2.14118H10.714V3.4269H11.9997V1.99833C11.9997 1.36797 11.4872 0.855469 10.8569 0.855469H5.14258C4.51222 0.855469 3.99972 1.36797 3.99972 1.99833V3.4269H5.28544V2.14118ZM14.2854 3.4269H1.71401C1.39794 3.4269 1.14258 3.68225 1.14258 3.99833V4.56976C1.14258 4.64833 1.20686 4.71261 1.28544 4.71261H2.36401L2.80508 14.0519C2.83365 14.6608 3.33722 15.1412 3.94615 15.1412H12.0533C12.664 15.1412 13.1658 14.6626 13.1944 14.0519L13.6354 4.71261H14.714C14.7926 4.71261 14.8569 4.64833 14.8569 4.56976V3.99833C14.8569 3.68225 14.6015 3.4269 14.2854 3.4269ZM11.9158 13.8555H4.08365L3.65151 4.71261H12.3479L11.9158 13.8555Z"
                  fill="#E00F57"
                />
              </svg>
            </button>
          </div>
        </template>
      </div>
    </div>
    <div
      class="p-6 px-8 rounded-md overflow-hidden shadow-lg lg:w-1/4 text-center"
    >
      <Form
        @submit="onSave"
        :validation-schema="{
          name: 'required',
        }"
      >
        <div class="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
          >
            <circle opacity="0.12" cx="40" cy="40" r="40" fill="#0057FF" />
            <g clip-path="url(#clip0_722:17558)">
              <path
                d="M57.6779 45.7143H53.035V38.9286C53.035 38.7321 52.8743 38.5714 52.6779 38.5714H41.6064V34.2857H46.4279C46.8207 34.2857 47.1422 33.9643 47.1422 33.5714V20.7143C47.1422 20.3214 46.8207 20 46.4279 20H33.5707C33.1779 20 32.8564 20.3214 32.8564 20.7143V33.5714C32.8564 33.9643 33.1779 34.2857 33.5707 34.2857H38.3922V38.5714H27.3207C27.1243 38.5714 26.9636 38.7321 26.9636 38.9286V45.7143H22.3207C21.9279 45.7143 21.6064 46.0357 21.6064 46.4286V59.2857C21.6064 59.6786 21.9279 60 22.3207 60H35.1779C35.5707 60 35.8922 59.6786 35.8922 59.2857V46.4286C35.8922 46.0357 35.5707 45.7143 35.1779 45.7143H30.1779V41.7857H49.8207V45.7143H44.8207C44.4279 45.7143 44.1064 46.0357 44.1064 46.4286V59.2857C44.1064 59.6786 44.4279 60 44.8207 60H57.6779C58.0707 60 58.3922 59.6786 58.3922 59.2857V46.4286C58.3922 46.0357 58.0707 45.7143 57.6779 45.7143ZM32.4993 49.1071V56.6071H24.9993V49.1071H32.4993ZM36.2493 30.8929V23.3929H43.7493V30.8929H36.2493ZM54.9993 56.6071H47.4993V49.1071H54.9993V56.6071Z"
                fill="#0057FF"
              />
            </g>
            <defs>
              <clipPath id="clip0_722:17558">
                <rect
                  width="40"
                  height="40"
                  fill="white"
                  transform="translate(20 20)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="p-4">
          <h4 class="text-blue-900 font-light">Crea nuevos roles de usuario</h4>
        </div>
        <div class="pb-4">
          <Field v-model="name" name="name" v-slot="{ field }">
            <input
              v-bind="field"
              type="text"
              class="
                relative
                py-3
                px-2
                w-full
                bg-white
                rounded
                border
                outline-none
                text-gray-700
                placeholder-gray-400
                focus:outline-none focus:shadow-outline
              "
              placeholder="Ingrese nombre del rol"
            />
          </Field>
          <div>
            <ErrorMessage name="name" v-slot="{ message }">
              <p class="text-red-500 pt-1 text-sm text-left">{{ message }}</p>
            </ErrorMessage>
          </div>
        </div>
        <div class="pt-4 pb-6">
          <h4 class="text-blue-900 font-light">
            ¿A que módulos tendrá acceso?
          </h4>
        </div>
        <div class="pb-4">
          <!-- Cronograma
          <div class="grid grid-cols-3 sm:grid-cols-3 pb-6">
            <div class="flex">
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.97737 2.21186C3.97737 2.09983 3.96776 1.9806 3.95792 1.85849C3.93498 1.57392 3.91078 1.27372 4.00402 1.01266C4.10136 0.740091 4.32672 0.495974 4.545 0.259522C4.6255 0.17232 4.70504 0.08616 4.77684 0C4.86027 0.100123 4.95416 0.197633 5.04868 0.295801L5.04868 0.295805C5.25605 0.511179 5.46647 0.729724 5.5763 0.985997C5.66711 1.22208 5.64653 1.50768 5.6242 1.81747C5.61377 1.96228 5.60295 2.11237 5.60295 2.26516H12.505C12.505 2.10779 12.4947 1.95043 12.4845 1.79467V1.79466V1.79465V1.79464V1.79463V1.79463C12.4619 1.44922 12.4398 1.11169 12.5317 0.799467C12.6116 0.47968 13.0113 0.0266424 13.2778 0.0266424C13.571 0.0266424 13.9974 0.426379 14.0773 0.746166C14.1687 1.03877 14.1472 1.38157 14.1247 1.74012V1.74013V1.74015V1.74016V1.74018V1.7402V1.74022C14.1144 1.90412 14.104 2.07131 14.104 2.2385C14.3971 2.2918 14.5836 2.31845 14.7968 2.3451C16.6623 2.58494 17.9414 3.89073 17.968 5.75616C18.0213 9.35376 18.0213 12.9514 17.968 16.549C17.9414 18.521 16.5557 19.9334 14.5836 19.96C10.8794 20.0133 7.17524 20.0133 3.47104 19.96C1.55232 19.9334 0.113273 18.6009 0.0599753 16.6822C-0.0199714 13.0313 -0.0199714 9.35376 0.0599753 5.67621C0.166571 3.67755 1.31248 2.71819 3.97737 2.21186ZM16.3425 8.47435H1.79215C1.79215 9.2814 1.7878 10.0884 1.78345 10.8955L1.78345 10.8956C1.77258 12.9133 1.7617 14.931 1.81881 16.9487C1.84545 17.7482 2.51168 18.3078 3.31115 18.3078C7.12194 18.3611 10.9327 18.3611 14.7169 18.3078C15.6229 18.3078 16.2892 17.6682 16.2892 16.7888C16.369 14.7122 16.3591 12.6506 16.3492 10.5703L16.3491 10.5695C16.3458 9.87361 16.3425 9.17565 16.3425 8.47435ZM3.79139 11.219C3.79139 10.686 4.24442 10.233 4.7774 10.233C5.31038 10.233 5.76341 10.686 5.76341 11.219C5.76341 11.752 5.31038 12.205 4.7774 12.205C4.21777 12.205 3.79139 11.752 3.79139 11.219ZM8.95987 10.233C8.42689 10.233 7.97387 10.686 7.97387 11.219C7.97387 11.752 8.42689 12.205 8.95987 12.205C9.49285 12.205 9.94588 11.752 9.94588 11.219C9.94588 10.686 9.49285 10.233 8.95987 10.233ZM12.3196 11.245C12.3196 10.712 12.7726 10.259 13.3056 10.259C13.8386 10.259 14.2916 10.712 14.2916 11.245C14.2916 11.778 13.8386 12.231 13.3056 12.231C12.746 12.231 12.3196 11.778 12.3196 11.245ZM4.80344 14.4694C4.27046 14.4694 3.81743 14.9224 3.81743 15.4554C3.81743 16.015 4.27046 16.4414 4.80344 16.4414C5.33642 16.4414 5.78945 15.9884 5.78945 15.4554C5.78945 14.9224 5.33642 14.4694 4.80344 14.4694ZM8.0027 15.4554C8.0027 14.9224 8.45572 14.4694 8.9887 14.4694C9.52168 14.4694 9.97472 14.9224 9.97472 15.4554C9.97472 15.9884 9.52168 16.4414 8.9887 16.4414C8.45572 16.4414 8.0027 16.015 8.0027 15.4554ZM13.3316 14.4968C12.7986 14.4968 12.3456 14.9499 12.3456 15.4829C12.3456 16.0425 12.7986 16.4689 13.3316 16.4689C13.8646 16.4689 14.3176 16.0158 14.3176 15.4829C14.3176 14.9499 13.8646 14.4968 13.3316 14.4968Z"
                    fill="#003D91"
                  /></svg
              ></span>
              <h4 class="text-sm font-medium text-secondary pl-1">
                Cronograma
              </h4>
            </div>
            <div class="flex items-center justify-center">
              <input
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-dark pl-2">
                Web
              </span>
            </div>
            <div class="flex items-center justify-center">
              <input
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-dark pl-2">
                Móvil
              </span>
            </div>
          </div>
          -- Cronograma -->
          <!-- Tareo -->
          <div class="grid grid-cols-3 sm:grid-cols-3 pb-6">
            <div class="flex">
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  fill="none"
                >
                  <path
                    d="M24 18.209C23.9104 18.4179 23.8508 18.6269 23.7314 18.806C23.4627 19.2537 23.0149 19.4627 22.5075 19.4627C21.2537 19.4627 20 19.4925 18.7761 19.4627C17.8806 19.4627 17.2537 18.806 17.2537 17.9105C17.2537 17.4328 17.2537 16.9552 17.2537 16.4478C17.2537 16.3582 17.2239 16.2687 17.1642 16.209C16.3881 15.5821 15.6119 14.9851 14.8358 14.3582C14.806 14.3582 14.806 14.3284 14.7761 14.3284C14.7463 14.3284 14.7463 14.3582 14.7164 14.3582C14.4776 14.5373 14.5075 14.7164 14.6269 14.9552C15.2836 16.1194 15.0448 17.7612 14.1194 18.7164C13.6418 19.194 13.0746 19.4627 12.3881 19.4627C9.13433 19.4627 5.8806 19.4627 2.62686 19.4627C1.40298 19.4627 0.388049 18.5672 0.119392 17.2537C-0.0597125 16.3881 0.0298435 15.5522 0.477605 14.7761C0.507456 14.7164 0.537303 14.6866 0.567154 14.597C0.0596906 14.1791 0 13.6119 0 12.9851C0 11.7015 0 10.4179 0 9.13433C0 8.08956 0.626859 7.46269 1.67164 7.46269C2.1194 7.46269 2.53731 7.46269 3.01492 7.46269V7.16418V1.67164C3.01492 0.626866 3.64178 0 4.68655 0C5.88059 0 7.04477 0 8.2388 0C10.3284 0 11.9701 1.19403 12.6567 3.19403C13.1343 4.59702 13.5821 6 14.0597 7.40299C14.1194 7.55224 14.1791 7.64179 14.2985 7.73135C14.7463 8.02985 14.9851 8.47762 14.9851 9.01493C14.9851 9.52239 14.9851 10 14.9851 10.5075C14.9851 10.597 15.0149 10.6866 15.0746 10.7164C15.7612 11.2537 16.4478 11.791 17.1343 12.3582C17.1642 12.3881 17.194 12.3881 17.2537 12.4179C17.2537 12.2388 17.2537 12.0896 17.2537 11.9702C17.2836 11.2836 17.7015 10.7164 18.3284 10.5373C18.9552 10.3582 19.6418 10.5672 20 11.1642C20.5672 12.0597 21.1343 12.9851 21.7015 13.8806C22.3582 14.9254 23.0149 15.9403 23.6418 16.9851C23.791 17.194 23.8806 17.4627 24 17.7015V18.209ZM10.9254 7.46269C10.9254 7.43284 10.8955 7.37314 10.8955 7.34329C10.5373 6.23881 10.1791 5.13433 9.79105 4.02985C9.55224 3.34329 9.01493 2.98508 8.29851 2.98508C7.64179 2.98508 6.95522 2.98508 6.2985 2.98508H6.0597V5.22388C6.68657 5.25373 7.19403 5.46269 7.61194 5.8806C8.02985 6.29851 8.26866 6.83582 8.29851 7.46269H10.9254ZM4.5373 16.4776C4.5373 15.6418 3.88058 14.9851 3.04476 14.9851C2.23879 14.9851 1.55222 15.6418 1.55222 16.4776C1.52237 17.2836 2.23879 18 3.04476 18C3.85073 17.9702 4.5373 17.2836 4.5373 16.4776ZM13.5224 16.4776C13.5224 15.6418 12.8358 14.9851 12.0299 14.9851C11.2239 14.9851 10.5373 15.6716 10.5373 16.4776C10.5373 17.2836 11.2239 17.9702 12.0299 17.9702C12.8657 17.9403 13.5224 17.2836 13.5224 16.4776ZM9.04478 16.4776C9.04478 15.6418 8.35821 14.9851 7.55224 14.9851C6.74627 14.9851 6.0597 15.6716 6.0597 16.4776C6.0597 17.2836 6.74627 17.9702 7.55224 17.9702C8.35821 17.9403 9.01493 17.2836 9.04478 16.4776Z"
                    fill="#003D91"
                  /></svg
              ></span>
              <h4 class="text-sm font-medium text-secondary pl-1">Tareo</h4>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[0].hasWebPermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Web
              </span>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[0].hasMobilePermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Móvil
              </span>
            </div>
          </div>
          <!-- Planificación -->
          <div class="grid grid-cols-3 sm:grid-cols-3 pb-6">
            <div class="flex items-center">
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.8985 1.93322H5.00804C4.32074 1.93322 3.60699 1.90679 3.58055 0.981564C3.55412 0.0827767 4.24143 -0.0229621 4.95517 0.00347279H14.9211C15.6349 0.00347279 16.3222 0.109213 16.2958 1.008C16.2693 1.90679 15.5556 1.95965 14.8683 1.95965C13.2294 1.93322 11.5642 1.93322 9.89895 1.93322H9.8985ZM9.89847 3.36064H16.2428C16.9566 3.36064 17.6439 3.43995 17.6703 4.33873C17.6968 5.23752 17.0095 5.3697 16.2957 5.3697H3.60696C2.89322 5.3697 2.20591 5.21108 2.23235 4.33873C2.25878 3.46638 2.94608 3.36064 3.65982 3.36064H9.89847ZM7.84041 19.9941C8.53358 19.9912 9.22774 19.9883 9.92484 19.9883H15.952H16.1635C18.4369 19.9618 19.8644 18.5872 19.9172 16.3138V16.3137C19.9437 14.4104 19.9701 12.5071 19.9172 10.6039C19.8644 8.33046 18.4105 6.90297 16.1635 6.90297C12.0132 6.87654 7.83649 6.87654 3.68621 6.90297C1.46568 6.90297 0.0381838 8.38333 0.0117488 10.551C-0.00587443 11.8199 0 13.0887 0.00587443 14.3576C0.00881164 14.9921 0.0117488 15.6265 0.0117488 16.2609C0.0381838 18.5608 1.41281 19.9618 3.68621 19.9883C5.07746 20.0059 6.45699 20 7.84041 19.9941ZM8.58946 13.6033C8.74008 13.7558 8.90627 13.9241 9.13179 14.1461C9.28885 13.981 9.44161 13.8202 9.59082 13.6631C10.4211 12.7891 11.1416 12.0306 11.881 11.2912C12.2776 10.8946 12.7269 10.6567 13.2292 11.1061C13.7843 11.6084 13.5464 12.0842 13.097 12.5336C12.0397 13.5645 10.9824 14.6218 9.92507 15.6791L9.92484 15.6794C9.42258 16.1816 8.92032 16.2345 8.39162 15.7322C8.26723 15.6135 8.14042 15.496 8.01352 15.3784C7.54712 14.9461 7.0795 14.5127 6.72622 14.014C6.51474 13.7232 6.2122 13.2175 6.64692 12.7451C7.13743 12.2922 7.6123 12.6513 7.93047 12.9531C8.19919 13.208 8.37914 13.3903 8.58946 13.6033Z"
                    fill="#003D91"
                  /></svg
              ></span>
              <h4 class="text-sm font-medium text-secondary pl-1">
                Planificación
              </h4>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[1].hasWebPermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Web
              </span>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[1].hasMobilePermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Móvil
              </span>
            </div>
          </div>
          <!-- Asistencia
          <div class="grid grid-cols-3 sm:grid-cols-3 pb-6">
            <div class="flex items-center">
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
                    fill="#003D91"
                  />
                  <path
                    d="M16.0947 14.965L12.7525 12.5486V6.7478C12.7525 6.64468 12.6682 6.5603 12.565 6.5603H11.4377C11.3346 6.5603 11.2502 6.64468 11.2502 6.7478V13.2025C11.2502 13.2634 11.2783 13.3197 11.3275 13.3548L15.2041 16.1814C15.2885 16.2423 15.4057 16.2236 15.4666 16.1416L16.1369 15.2275C16.1978 15.1408 16.1791 15.0236 16.0947 14.965Z"
                    fill="#003D91"
                  /></svg
              ></span>
              <h4 class="text-sm font-medium text-secondary pl-1">
                Asistencia
              </h4>
            </div>
            <div class="flex items-center justify-center">
              <input
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Web
              </span>
            </div>
            <div class="flex items-center justify-center">
              <input
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Móvil
              </span>
            </div>
          </div>
          -- Asistencia -->
          <!-- Planos -->
          <div class="grid grid-cols-3 sm:grid-cols-3 pb-6">
            <div class="flex items-center">
              <span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M23.143 8.78571C23.3787 8.78571 23.5716 8.59286 23.5716 8.35714V3.42857C23.5716 3.19286 23.3787 3 23.143 3H18.2144C17.9787 3 17.7859 3.19286 17.7859 3.42857V4.92857H6.21443V3.42857C6.21443 3.19286 6.02157 3 5.78585 3H0.857282C0.621568 3 0.428711 3.19286 0.428711 3.42857V8.35714C0.428711 8.59286 0.621568 8.78571 0.857282 8.78571H2.35728V15.2143H0.857282C0.621568 15.2143 0.428711 15.4071 0.428711 15.6429V20.5714C0.428711 20.8071 0.621568 21 0.857282 21H5.78585C6.02157 21 6.21443 20.8071 6.21443 20.5714V19.0714H17.7859V20.5714C17.7859 20.8071 17.9787 21 18.2144 21H23.143C23.3787 21 23.5716 20.8071 23.5716 20.5714V15.6429C23.5716 15.4071 23.3787 15.2143 23.143 15.2143H21.643V8.78571H23.143ZM19.5001 4.71429H21.8573V7.07143H19.5001V4.71429ZM2.143 7.07143V4.71429H4.50014V7.07143H2.143ZM4.50014 19.2857H2.143V16.9286H4.50014V19.2857ZM21.8573 16.9286V19.2857H19.5001V16.9286H21.8573ZM19.7144 15.2143H18.2144C17.9787 15.2143 17.7859 15.4071 17.7859 15.6429V17.1429H6.21443V15.6429C6.21443 15.4071 6.02157 15.2143 5.78585 15.2143H4.28585V8.78571H5.78585C6.02157 8.78571 6.21443 8.59286 6.21443 8.35714V6.85714H17.7859V8.35714C17.7859 8.59286 17.9787 8.78571 18.2144 8.78571H19.7144V15.2143Z"
                    fill="#003D91"
                  /></svg
              ></span>
              <h4 class="text-sm font-medium text-secondary pl-1">Planos</h4>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[2].hasWebPermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Web
              </span>
            </div>
            <div class="flex items-center justify-center">
              <input
                v-model="permissions[2].hasMobilePermissions"
                type="checkbox"
                class="
                  checked:bg-primary checked:border-transparent
                  cursor-pointer
                  ...
                "
              />
              <span class="select-none text-sm font-medium text-primary pl-2">
                Móvil
              </span>
            </div>
          </div>
        </div>
        <div>
          <button
            class="rounded-md bg-primary py-2 px-8 text-white font-medium"
            type="submit"
          >
            Crear rol
          </button>
        </div>
      </Form>
      <hr class="mt-8 mb-8" />
      <div>
        <p
          class="text-primary cursor-pointer underline text-sm font-regular"
          @click="onContinue"
        >
          {{ getRoles && getRoles.length ? "Continuar" : "Omitir y continuar" }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, defineEmits, ref, computed } from "vue";
import { useStore } from "vuex";
import { useField } from "vee-validate";

const store = useStore();
const app = getCurrentInstance();
const modules = app.appContext.config.globalProperties.$modules;

const emit = defineEmits(["onContinue"]);

const onContinue = () => {
  emit("onContinue", 3);
};

const { value: name } = useField("name");

const permissions = ref([
  {
    module: modules.TAREO,
    hasMobilePermissions: false,
    hasWebPermissions: false,
  },
  {
    module: modules.PLANIFICACION,
    hasMobilePermissions: false,
    hasWebPermissions: false,
  },
  {
    module: modules.PLANOS,
    hasMobilePermissions: false,
    hasWebPermissions: false,
  },
]);

const getWork = computed(() => store.getters.getWork);
const getRoles = computed(() => store.getters.getRoles);

const resetPermissions = () => {
  permissions.value = permissions.value.map((p) => ({
    ...p,
    hasWebPermissions: false,
    hasMobilePermissions: false,
  }));
};

const onSave = async (values, { resetForm }) => {
  try {
    await store.dispatch("createRole", {
      role: {
        workKey: getWork.value.key,
        name: values.name,
        permissions: permissions.value,
      },
    });

    resetForm();
    resetPermissions();
  } catch (error) {
    console.error(error);
  }
};

const onDelete = async (key) => {
  try {
    await store.dispatch("deleteRole", { key });
  } catch (error) {
    console.error(error);
  }
};
</script>
